import { render, staticRenderFns } from "./Articulo_editar.vue?vue&type=template&id=c0ff290a"
import script from "./Articulo_editar.vue?vue&type=script&lang=js"
export * from "./Articulo_editar.vue?vue&type=script&lang=js"
import style0 from "./Articulo_editar.vue?vue&type=style&index=0&id=c0ff290a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports